import 'react-circular-progressbar/dist/styles.css'

import { memo, useEffect, useState } from 'react'
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from 'react-circular-progressbar'

import { PersonQuestion } from '../Icons'

const MentorLoader: React.FC = memo(() => {
  const [value, setValue] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setValue(prev => {
        if (prev >= 100) {
          return 0
        }
        return prev + 0.25
      })
    }, 100)

    return () => clearInterval(interval)
  }, [])

  return (
    <CircularProgressbarWithChildren
      value={value}
      counterClockwise
      strokeWidth={6}
      styles={buildStyles({
        pathColor: '#C1C1CA',
        strokeLinecap: 'butt',
        trailColor: 'rgb(147 147 163)',
        pathTransition: 'none',
      })}
    >
      <PersonQuestion />
    </CircularProgressbarWithChildren>
  )
})

export { MentorLoader }
